/**
 * @generated SignedSource<<7bdfbdca276419f5a551ac3e2318a29b>>
 * @relayHash ab89d2e9ebc6bb831152243ac816a4bd
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ab89d2e9ebc6bb831152243ac816a4bd

import { ConcreteRequest } from 'relay-runtime';
export type RegisterVisitorProductizedServiceViewEventInput = {
  currentUrl?: any | null;
  productizedServiceId: string;
  referrerUrl?: any | null;
};
export type useSendAnalyticEventMutationProductizedServiceViewEventMutation$variables = {
  input: RegisterVisitorProductizedServiceViewEventInput;
};
export type useSendAnalyticEventMutationProductizedServiceViewEventMutation$data = {
  readonly registerVisitorProductizedServiceViewEvent: {
    readonly registered: boolean;
  };
};
export type useSendAnalyticEventMutationProductizedServiceViewEventMutation = {
  response: useSendAnalyticEventMutationProductizedServiceViewEventMutation$data;
  variables: useSendAnalyticEventMutationProductizedServiceViewEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RegisterVisitorProductizedServiceViewEventPayload",
    "kind": "LinkedField",
    "name": "registerVisitorProductizedServiceViewEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "registered",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSendAnalyticEventMutationProductizedServiceViewEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSendAnalyticEventMutationProductizedServiceViewEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ab89d2e9ebc6bb831152243ac816a4bd",
    "metadata": {},
    "name": "useSendAnalyticEventMutationProductizedServiceViewEventMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "64b4790e6e4d23194916f89592575652";

export default node;
